import {ReactNode} from 'react';
import { InputNumber } from 'antd';
import './inputNumber.scss';

type InputNumberComponentParams = {
    value: number|null|undefined
    className: string
    onChangeEvent: (value: number|string|null) => void
    style?: {}
    status?: "" | "warning" | "error" | undefined
    statusMsg?:string
    addonAfter?:ReactNode
    min:number
    max?:number
    step: number
    placeholder?:string
    precision?:number
    formatter?: ((value: number | undefined, info: { userTyping: boolean; input: string; }) => string) | undefined
    parser?: any
    controls?: any
    disabled?:boolean
    onBlurEvent?: (event:any) => void
}

const InputNumberComponent = ({
    value,
    className = '',
    onChangeEvent,
    style = {},
    status = '',
    statusMsg = '',
    addonAfter,
    min = 0,
    max,
    step = 1,
    placeholder = '',
    precision,
    formatter,
    parser,
    controls,
    disabled,
    onBlurEvent,
}:InputNumberComponentParams) => {
    return (
        <>
            <InputNumber
                // className={className}
                value={value}
                onChange={onChangeEvent}
                style={style}
                status={status}
                addonAfter={addonAfter}
                min={min}
                step={step}
                max={max}
                precision={precision}
                placeholder={placeholder}
                formatter={formatter}
                parser={parser}
                controls={controls}
                disabled={disabled}
                onBlur={onBlurEvent}
            />
            {statusMsg && <p className='mandatoryMsg'>{statusMsg}</p>}
        </>
    );
};

const Demo = () => {
    return (<><InputNumber min={0}/></>);
}
export default InputNumberComponent;
